import { AbstractControl } from "@angular/forms";

export function dutchPersonalNumberValidator(control: AbstractControl): { format?: boolean } | null {
	/** Validate BSN according to http://nl.wikipedia.org/wiki/Burgerservicenummer */
	if (!control.value) {
		return null;
	}

	let value = String(control.value);
	/** the citizen service number consists of 8 or 9 digits **/
	if (value.length < 8 || value.length > 9) {
		return { format: false };
	}

	value = value.padStart(9, "0");
	let bsnCounter = 0;
	let sum = 0;
	for (let i = 9; i >= 1; i--) {
		const bsnNumber = parseInt(value[bsnCounter], 10);
		if (i === 1) {
			sum = sum - bsnNumber * i;
		} else {
			sum = sum + bsnNumber * i;
		}
		bsnCounter++;
	}

	/** Requiring the result to be greater than 0 prevents a number consisting of all zeros from being considered valid. **/
	if (sum > 0 && sum % 11 === 0) {
		return null;
	}

	return { format: false };
}
